module.exports = {
	  // api: "http://39.104.62.243:8804"//测试环境
	  // api: "http://192.168.0.185:3000"//测试环境
	   // api: "https://it97xy.cn:8000"//测试环境
	   // api: "http://192.168.0.46:9527"
	   // api: "http://192.168.0.87:9527"
	   // api: "http://192.168.0.35:9527"
	   // api: "http://192.168.0.185:3000"
	   // api: "https://qjy.magicfarm.cn/qjy"
	   api: "https://qjy.magicfarm.cn/qjy"
	// api: "https://trace.magicfarm.cn/qjy"
}
